import React from 'react';

const SummaryBar = ({ bookings, selected, onSelect }) => {
    const total = bookings.length;
    const upcoming = bookings.filter((b) => b.status === 'Scheduled' || b.status === 'Rescheduled').length;
    const completed = bookings.filter((b) => b.status === 'Completed').length;
    const cancelled = bookings.filter((b) => b.status === 'Cancelled').length;

    const tiles = [
        { label: 'Total', value: total, valueClass: 'text-gray-800', filterValue: 'All' },
        { label: 'Upcoming', value: upcoming, valueClass: 'text-indigo-600', filterValue: 'Upcoming' },
        { label: 'Completed', value: completed, valueClass: 'text-blue-600', filterValue: 'Completed' },
        { label: 'Cancelled', value: cancelled, valueClass: 'text-red-600', filterValue: 'Cancelled' },
    ];

    return (
        <div className="flex flex-wrap gap-2 mb-4">
            {tiles.map((t) => {
                const isActive = selected === t.filterValue;
                return (
                    <button
                        key={t.label}
                        onClick={() => onSelect(t.filterValue)}
                        className={`flex-1 min-w-[70px] rounded-xl py-3 text-center transition-colors ${isActive ? 'bg-indigo-900' : 'bg-white hover:bg-gray-50'
                            }`}
                    >
                        <p className={`text-xl font-bold ${isActive ? 'text-white' : t.valueClass}`}>{t.value}</p>
                        <p className={`text-xs mt-0.5 ${isActive ? 'text-white' : 'text-gray-500'}`}>{t.label}</p>
                    </button>
                );
            })}
        </div>
    );
};

export default SummaryBar;
